module.exports = __webpack_public_path__ + "static/marketing-4e0063c97fd8d14453a97a1a9bef44bc.jpg";